export default __webpack_public_path__ + "static/media/TokiRGB_purple.83558e89.png";